import { render, staticRenderFns } from "./pluginList.vue?vue&type=template&id=7f8a31ea&scoped=true&"
import script from "./pluginList.vue?vue&type=script&lang=js&"
export * from "./pluginList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8a31ea",
  null
  
)

export default component.exports